import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useTranslations } from '../../locales/useTranslations';

const ItConsultingProjekte = () => {
    const { t } = useTranslations();

    return (
        <section className="case-studies-area pt-100 pb-70">
            <div className="container">
                <div className="section-title text-left">
                    <span className="sub-title">{t('itConsulting_projects_subtitle')}</span>
                    <h2>{t('itConsulting_projects_title')}</h2>
                </div>
            </div>

            <div className="features-card-section ">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-sm-12 feature-card ">
                            <div className="single-features-card">
                                <Link href="https://playfit.de/" target="_blank">
                                    <Image
                                        src="/images/partner/logo-playfit.png"
                                        className="responsive-img"
                                        alt="logo - playfit gmbh"
                                        width={0}
                                        height={0}
                                        sizes="60vw"
                                        style={{ width: 'auto', height: '40px' }} />
                                </Link>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="container">
                <div className="row">
                    <p className="text-white">{t('itConsulting_projects_description')}</p>
                </div>
            </div>
        </section>
    );
}

export default ItConsultingProjekte;